exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background{padding-top:14px}.el-table .warning-row{color:red}@media screen and (max-width: 600px){.space{margin-bottom:4px}}\n", ""]);

// exports
